<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >交易币种设置</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="交易币种设置"
      width="1000px"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="120px">
        <el-form-item label="已有配置：" prop="coinType">
          <div class="coinlist">
            <span>币种</span>
            <span>系统最小限额</span>
            <span>币种精度</span>
            <span>操作</span>
          </div>
          <div v-for="item in coinLists" :key="item.coinType" class="coinlist">
            <span>{{ item.coinType }}</span>
            <span>{{ item.minOrderAmount }}</span>
            <span>{{ item.precision }}</span>
            <span @click="handleremove(item.coinType)">
              <i class="el-icon-error"></i>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="添加币种：" prop="coinType">
          <el-select v-model="coinType" placeholder="请选择币种">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统最小限额：" prop="coinType">
          <el-input v-model="minOrderAmount"></el-input>
        </el-form-item>
        <el-form-item label="币种精度：" prop="coinType">
          <el-input v-model="precision"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'setnote',
  data() {
    return {
      dialogVisible: false,
      coinType: '',
      minOrderAmount: '',
      precision: ''
    };
  },
  components: {},
  computed: {
    ...mapState('recharge', ['coinList']),
    ...mapState('merchant', ['coinLists'])
  },
  methods: {
    ...mapActions('merchant', ['getCoinList', 'addCoin', 'deleteCoin']),
    closeDialog() {
      this.dialogVisible = false;
      this.coinType = '';
      this.minOrderAmount = '';
      this.precision = '';
    },
    handleSave() {
      this.addCoin({
        coinType: this.coinType,
        minOrderAmount: this.minOrderAmount,
        precision: this.precision
      }).then(() => {
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.getCoinList();
        this.coinType = '';
        this.minOrderAmount = '';
        this.precision = '';
      });
    },
    handleremove(coinType) {
      const message = '确定删除该配置吗';
      this.$confirm(message, '提示', {
        type: 'warning'
      }).then(() => {
        this.deleteCoin({
          coinType: coinType
        }).then(() => {
          this.$message.success('删除成功！');
          this.getCoinList();
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-input {
  width: 40%;
}
.coinlist {
  display: flex;
  span {
    width: 100px;
    text-align: center;
  }
}
</style>
